export const updatePageUrl = ({
	page,
	pageQueryParam,
	isInPreviewMode = false,
}: {
	page: number;
	pageQueryParam: string;
	isInPreviewMode?: boolean;
}) => {
	if (isInPreviewMode) {
		return;
	}

	const url = new URL(window.location.href);

	if (page > 1) {
		url.searchParams.set(pageQueryParam, page.toString());
	} else {
		// Remove page parameter when on first page
		url.searchParams.delete(pageQueryParam);
	}

	if (url.toString() !== window.location.href) {
		window.history.pushState({}, '', url.toString());
	}
};
